import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises";

export default {
  fetch() {
    return http.get(`${resource}/shipping_agencies`);
  },

  fetchDetail(itemId) {
    return http.get(`${resource}/shipping_agencies/${itemId}`);
  },

  update(itemId, payload) {
    return http.put(`${resource}/shipping_agencies/${itemId}`, payload);
  },

  search(payload) {
    return http.get(`${resource}/shipping_agencies/search`, { params: payload });
  },

  add(payload) {
    return http.post(`${resource}/shipping_agencies`, payload);
  },

  delete(itemId) {
    return http.delete(`${resource}/shipping_agencies/${itemId}`);
  },
};
